import React, { useRef, useState, useEffect } from 'react';
import './HomeView.css';
import 'intersection-observer';
import Suggestion from '../Suggestion/Suggestion';
import { useDispatch, useSelector } from 'react-redux';
import { getUserId } from '../../store/User/UserSelectors';
import { getSuggestions } from '../../store/Suggestions/SuggestionsSelectors';
import { sendMessageAction } from '../../store/Messages/MessagesActions';
import { getTenantConfig } from '../../store/Config/configSelectors';

const HomeView = ({ setHome, sendGAEvent }) => {
  const dispatch = useDispatch();
  useRef(null);
  useSelector(getUserId);

  const suggestions = useSelector(getSuggestions);
  const { homeContentClass, homeContentStyle } = useSelector(getTenantConfig);

  const [shouldShowSuggestions, setShouldShowSuggestions] = useState(false);

  const [visibleSuggestions, setVisibleSuggestions] = useState([]);

  const sendMessage = async message => {
    setHome(false);
    sendGAEvent();
    dispatch(sendMessageAction(message));
  };

  const renderSuggestions = suggestions => {
    return (
      <div className="home-suggestions">
        {suggestions.map((suggestion, index) => (
          <Suggestion
            key={index}
            text={suggestion}
            sendMessage={sendMessage}
            setHome={setHome}
            index={index}
          />
        ))}
      </div>
    );
  };

  const isInIframe = window.self !== window.top; // Check if inside iframe

  useEffect(() => {
    if (isInIframe) {
      // Listen for postMessage from Squarespace parent
      const handleMessage = event => {
        if (event.data === 'chatOpened') {
          console.log('Chat opened inside iframe...');
          setShouldShowSuggestions(true); // Mark as ready to show
        }
      };

      window.addEventListener('message', handleMessage);
      return () => {
        window.removeEventListener('message', handleMessage);
      };
    }
  }, [isInIframe]);

  useEffect(() => {
    if (
      suggestions.length > 0 &&
      visibleSuggestions.length <= suggestions.length &&
      shouldShowSuggestions
    )
      suggestions.forEach((message, index) => {
        setTimeout(() => {
          setVisibleSuggestions(prev => [...prev, message]);
        }, index * 100); // 500ms delay between each message
      });
  }, [suggestions.length, shouldShowSuggestions]);

  return (
    <div
      className={`Home-content ${homeContentClass}`}
      style={homeContentStyle}
    >
      {visibleSuggestions?.length > 0 && renderSuggestions(visibleSuggestions)}
    </div>
  );
};

export default HomeView;
